





















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class DocUploadIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#522cdf' }) readonly color?: string;
  @Prop({ default: '#E2E7FF' }) readonly colorCircle?: string;
}
